// Angular Modules
import { BrowserModule } from '@angular/platform-browser';
import { DecimalPipe, CurrencyPipe } from '@angular/common';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Common (Components) Modules
import { CommonComponentsModule } from './modules/shared/common-components.module';
import { CdkTableModule } from '@angular/cdk/table';
import { PipesDirectivesModule } from './modules/shared/pipes-directives.module';

// Routing Modules
import { AppRoutingModule } from './app-routing.module';

// Components
import { AppComponent } from './app.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { SandboxComponent } from './sandbox/sandbox.component';
import { TopNavComponent } from './components/top-nav/top-nav.component';
import { LoggedOutPageComponent } from './pages/logged-out-page/logged-out-page.component';
import { AuthCallbackPageComponent } from './pages/auth-callback-page/auth-callback-page.component';

// Specialized Hacks
import { UnauthorizedPageComponent } from './pages/unauthorized-page/unauthorized-page.component';

// Dynamic Components Module and Manifest
// import { DynamicComponentLoaderModule } from './dynamic-component-loader/dynamic-component-loader.module';
// import { manifestArray } from './dynamic-component-loader/dynamic-component-manifest-array';

import { CurrencyInterceptor } from './api/currency.interceptor';
import { UserSurveyComponent } from './components/user-survey/user-survey.component';
import { DeepLinkingPageComponent } from './pages/deeplinking-page/deeplinking-page.component';
import { LocaleService } from './locale.service';

import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';

// Register all community features
ModuleRegistry.registerModules([AllCommunityModule]);

// Mark all grids as using legacy themes
provideGlobalGridOptions({ theme: "legacy"});
@NgModule({
  declarations: [
    AppComponent,
    SandboxComponent,
    TopNavComponent,
    LoggedOutPageComponent,
    AuthCallbackPageComponent,
    UnauthorizedPageComponent,
    HomePageComponent,
    PageNotFoundComponent,
    UserSurveyComponent,
    DeepLinkingPageComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    // Common Components
    CommonComponentsModule,
    CdkTableModule,
    AppRoutingModule,
    PipesDirectivesModule
    // DynamicComponentLoaderModule.forRoot(manifestArray),
  ],
  providers: [
    {
      provide: LOCALE_ID,
      deps: [LocaleService],
      useFactory: (localeService: any) => localeService.getLocale()
    },
    DecimalPipe,
    CurrencyPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CurrencyInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {}
}
